import { object } from 'yup'
import { IPlanner } from '../../interfaces/Planner/Planner'
import { configDateInitial } from '../../utils/dateHelper'
import * as yup from 'yup'
import { DataGridSettings } from '../../interfaces/DataGrid/DataGridSettings'

export const definicionColumna: any[] = [
  {
    field: 'id',
    headerName: 'ID de Pedido',
    flex: 1,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'courierId',
    headerName: 'Courier',
    flex: 1,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'courierServiceId',
    headerName: 'Serrvicio',
    flex: 1,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'quantity',
    headerName: 'Cantad de Unidades',
    flex: 1,
    headerAlign: 'center',
    align: 'center'
  }
]

export const busquedaInitialState: IPlanner = {
  id: 0,
  neighborhoodId: 0,
  courierId: 0,
  courierServiceId: 0,
  orderStateId: 0,
  initialDeliveryDate: configDateInitial(60),
  finalDeliveryDate: configDateInitial(-30),
  initialCreatedDate: configDateInitial(7),
  finalCreatedDate: configDateInitial(0),
  quantity: 0,
  numberUnitsInitial: 0,
  numberUnitsFinal: 0,
  byUnit: false,
  byMonoSKU: false,
  referenceId: '',
  typeWorkOrderId: 0,
  sku: '',
  workOrderId: 0,
  workOrderStateId: -1,
  orderOriginId: 0,
  origin: '',
  workOrderTag: '',
  includeWithoutTag: false,
  orderReferenceId: '',
  ordersWithWorkOrder: false,
  ordersWithCancellationRequest: false,
  typeOrderId: 0
}

export const plannerValidationSchema = object({
  initialDeliveryDate: yup.string().required('Requiere fecha')
})

interface WorkOrderType {
  idTipoOT: number
  tipoOT: string
}

export const EnumWorkOrderType: WorkOrderType[] = [
  {
    idTipoOT: 1,
    tipoOT: 'INBOUND'
  },

  {
    idTipoOT: 2,
    tipoOT: 'OUTBOUND'
  }
]

export const dataGridSettings: DataGridSettings = {
  spacing: 2,
  sortingMode: 'single',
  columns: [
    {
      title: 'Sel.',
      dataField: 'column-check',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'ID de Pedido',
      dataField: 'referenceId',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    },
    {
      title: 'Promesa Entrega',
      dataField: 'courierDeliveryDate',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    },
    {
      title: 'Courier',
      dataField: 'courierData',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    },
    {
      title: 'Unidades',
      dataField: 'quantity',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'Ubicación',
      dataField: 'ubicacionData',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    },
    {
      title: 'Acción',
      dataField: 'column-buttons',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    }
  ]
}

export const dataGridSettingsOT: DataGridSettings = {
  spacing: 2,
  sortingMode: 'single',
  columns: [
    {
      title: 'SEL.',
      dataField: 'column-check',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false,
      childComp: true
    },
    {
      title: 'Id OT',
      dataField: 'id',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: true
    },
    {
      title: 'Estado',
      dataField: 'workOrderStateId',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: true
    },
    {
      title: 'Promesa Entrega',
      dataField: 'courierDeliveryDate',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: true,
      sortOrder: 'ASC'
    },
    {
      title: 'Creado',
      dataField: 'createdAt',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: true
    },
    {
      title: 'Unid.',
      dataField: 'quantity',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: true
    },
    {
      title: 'ID de Pedido',
      dataField: 'workOrderDetails',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    },
    {
      title: 'Acción',
      dataField: 'column-buttons',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    }
  ]
}
